import React from "react"

function ZoomIn({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.8333 16.3333H16.3333M16.3333 16.3333H18.8333M16.3333 16.3333V13.8333M16.3333 16.3333V18.8333M20.5 20.5L25.5 25.5M16.3333 22.1667C13.1117 22.1667 10.5 19.555 10.5 16.3333C10.5 13.1117 13.1117 10.5 16.3333 10.5C19.555 10.5 22.1667 13.1117 22.1667 16.3333C22.1667 19.555 19.555 22.1667 16.3333 22.1667Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default ZoomIn
